import { useContext } from 'react';
import { DatasetSessionStorageContext } from '../../context/DatasetSessionStorageContext/DatasetSessionStorageContext';

export const useDatasetSessionStorageContext = () => {
  const context = useContext(DatasetSessionStorageContext);

  if (context.isProvided === false) {
    throw new Error(
      'useDatasetSessionStorageContext must be used within a DatasetSessionStorageContextProvider'
    );
  }

  return context;
};
